import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const migrationBenefits = [
  { icon: 'ri-time-line', title: 'Kesinti Süresini Minimize', desc: 'Hızlı migrasyon iş sürekliliğini sağlar ve operasyonların aksamasını minimize eder.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Maliyet Tasarrufu', desc: 'Hızlı migrasyon paralel hiper yönetici ve donanım çalıştırma ihtiyacını ortadan kaldırır.' },
  { icon: 'ri-test-tube-line', title: 'Geliştirme Testi', desc: 'Yakın migrasyon, kapsamlı uyumluluk ve performans testi için test ortamları oluşturmayı sağlar.' },
  { icon: 'ri-shield-check-line', title: 'Sıfır Migrasyon Sonrası Tuning', desc: 'VergeOS tüm ayarları dönüştürür. Ağları veya VM ayarlarını yeniden yapılandırmaya gerek yoktur.' },
];

const howItWorks = [
  { icon: 'ri-building-4-line', title: 'Birleşik Mimari', desc: 'Sanallaştırma, depolama ve ağı tek akıcı çözümde birleştirir; verimsizlikleri ortadan kaldırır.' },
  { icon: 'ri-exchange-line', title: 'Kusursuz Entegrasyon', desc: 'VergeOS ioMigrate, Yedekleme API\'sini kullanarak veri kopyasını hassas biçimde alır.' },
  { icon: 'ri-database-2-line', title: 'CBT Desteği', desc: 'Changed Block Tracking (CBT) desteği ile cut-over süresi birkaç saniyeye iner.' },
  { icon: 'ri-global-line', title: 'Global Satır İçi Tekilleştirme', desc: 'Migrasyon öncesi ve sonrasında global tekilleştirme ile depolama ihtiyaçlarını azaltır.' },
];

const faqList = [
  { q: 'ioMigrate\'i diğer alternatiflerinden farklı kılan nedir?', a: 'ioMigrate benzersizdir çünkü sanallaştırma, depolama ve ağı tek bir yazılım paketinde birleştirir. Bu birleşik mimari; eski sistemlerde yaygın olan verimsizlikleri ve katmanları ortadan kaldırarak daha verimli, daha basit operasyonlara olanak tanır.' },
  { q: 'ioMigrate  VM\'leri ne kadar hızlı migrate edebilir?', a: 'ioMigrate, 100 VM\'i 2 dakikadan kısa sürede taşıyabilir. Gerçek bir gösterimde 100 VM\'yi yaklaşık 2 dakikada taşıdık ve ölçeklenebilir ortamlar için kurulumu gösterdik.' },
  { q: 'ioMigrate\'in iki aşamalı yaklaşımı neden avantajlıdır?', a: 'ioMigrate\'in iki aşamalı yaklaşımı hızı ve veri doğruluğunu dengeler. İlk aşamada VM verileri çalışmaya devam ederken kopyalanır. İkinci aşamada yalnızca değişiklikler senkronize edilir. Bu cut-over\'ı minimize ederek iş sürekliliği sağlar.' },
  { q: 'Migrasyon sırasında CBT kullanmanın avantajı nedir?', a: 'Changed Block Tracking (CBT), yalnızca değişen veri bloklarını izleyerek ikinci aşama migrasyon süresini dramatik biçimde kısaltır. CBT ile cut-over birkaç saniyeye kadar iner.' },
  { q: 'ioMigrate ile migrasyon sonrası yapılandırma gerekiyor mu?', a: 'Hayır. ioMigrate tüm ayarlarını dönüştürür; ağları veya VM yapılandırmalarını yeniden oluşturmanıza gerek yoktur. Bu özellik migrasyon süresini ve karmaşıklığını önemli ölçüde azaltır.' },
  { q: 'VergeOS\'a geçiş sonrasında sağlanan avantajlar nelerdir?', a: 'VergeOS\'a geçiş; kaynak kullanımını optimize ederek operasyonel maliyetleri azaltır, güvenli çok kiracılılık sağlar, iş yükleri büyüdükçe kolayca ölçeklenmenizi sağlar, kullanıcı dostu arayüz ile yönetimi basitleştirir ve uygulama hızını artırır.' },
  { q: 'Mevcut ortamdan ioMigrate ile migrate etmek güvenli midir?', a: 'Evet. ioMigrate canlı ortamdan çıkarma işlemi yapmaz; bunun yerine ortamınız çalışmaya devam ederken verileri kopyalar. Bu yaklaşım kesintisiz migrasyon sağlar.' },
];

const iomigrateJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'ioMigrate',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: "VMware'den VergeOS'a sorunsuz geçiş. Changed Block Tracking ile 100 VM'yi dakikalar içinde taşıyın, sıfır kesinti.",
  url: `${SITE_URL}/iomigrate`,
};

const iomigrateFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: "ioMigrate'i diğer alternatiflerinden farklı kılan nedir?", acceptedAnswer: { '@type': 'Answer', text: 'ioMigrate benzersizdir çünkü sanallaştırma, depolama ve ağı tek bir yazılım paketinde birleştirir. Bu birleşik mimari; eski sistemlerde yaygın olan verimsizlikleri ve katmanları ortadan kaldırarak daha verimli, daha basit operasyonlara olanak tanır.' } },
    { '@type': 'Question', name: "ioMigrate VM'leri ne kadar hızlı migrate edebilir?", acceptedAnswer: { '@type': 'Answer', text: "ioMigrate, 100 VM'i 2 dakikadan kısa sürede taşıyabilir. Gerçek bir gösterimde 100 VM'yi yaklaşık 2 dakikada taşıdık." } },
    { '@type': 'Question', name: 'Migrasyon sırasında CBT kullanmanın avantajı nedir?', acceptedAnswer: { '@type': 'Answer', text: 'Changed Block Tracking (CBT), yalnızca değişen veri bloklarını izleyerek ikinci aşama migrasyon süresini dramatik biçimde kısaltır. CBT ile cut-over birkaç saniyeye kadar iner.' } },
    { '@type': 'Question', name: 'ioMigrate ile migrasyon sonrası yapılandırma gerekiyor mu?', acceptedAnswer: { '@type': 'Answer', text: 'Hayır. ioMigrate tüm ayarlarını dönüştürür; ağları veya VM yapılandırmalarını yeniden oluşturmanıza gerek yoktur. Bu özellik migrasyon süresini ve karmaşıklığını önemli ölçüde azaltır.' } },
    { '@type': 'Question', name: 'Mevcut ortamdan ioMigrate ile migrate etmek güvenli midir?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. ioMigrate canlı ortamdan çıkarma işlemi yapmaz; bunun yerine ortamınız çalışmaya devam ederken verileri kopyalar. Bu yaklaşım kesintisiz migrasyon sağlar.' } },
  ],
};

export default function IoMigratePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="ioMigrate | VMware'den VergeOS'a Sorunsuz Geçiş"
        description="ioMigrate ile VMware'den VergeOS'a sorunsuz geçiş. CBT (Changed Block Tracking) desteğiyle 100 VM'yi dakikalar içinde taşıyın, sıfır kesinti migrasyonu."
        keywords="ioMigrate, VMware migration, VM migration, VergeOS, geçiş, CBT, Changed Block Tracking"
        canonicalPath="/iomigrate"
        jsonLd={[iomigrateJsonLd, iomigrateFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">Özellikler</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">ioMigrate</span> ile Migration
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">ioMigrate ile Hızlı Migrasyonunun Gücünü Deneyimleyin</p>
            <p className="text-gray-400 text-sm mb-8 max-w-2xl mx-auto">VergeOS yeni bir VMware migrasyon standardı belirliyor — eşi benzeri görülmemiş hız ve verimlilik ile.</p>
          </div>
        </section>

        {/* Rapid Migration */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Hızlı Migrasyon</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeOS, migrasyonda eşi benzeri görülmemiş hız ve verimlilik ile yeni bir standart belirliyor. Gerçek bir gösterimde <strong className="text-[#1e293b]">100'den fazla VM'ini 5 saniyeden kısa sürede</strong> migrate ettik. Bu düzey performans iş sürekliliğini dramatik biçimde sağlar ve operasyonların kesintiye uğramasını minimize eder.</p>
                <div className="grid grid-cols-3 gap-4 mb-6">
                  {[
                    { metric: '100+', label: 'VM 5 saniyede' },
                    { metric: 'Sıfır', label: 'Migrasyon sonrası tuning' },
                    { metric: '%100', label: 'ayar aktarımı' },
                  ].map(m => (
                    <div key={m.label} className="bg-[#f8fafc] rounded-lg p-4 text-center border border-gray-100">
                      <p className="text-2xl font-extrabold text-[#e8600a]">{m.metric}</p>
                      <p className="text-xs text-gray-600 mt-1">{m.label}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/932a12d28d87b2c0b595c567f3ca44d1.jpg" alt="ioMigrate VMware Migrasyonu" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Hızlı Migrasyon Neden Önemli</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {migrationBenefits.map(b => (
                <div key={b.title} className="bg-white rounded-lg border border-gray-100 p-6 text-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mx-auto mb-4"><i className={`${b.icon} text-2xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{b.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">VergeOS Bunu Nasıl Yapıyor</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">ioMigrate'in migrasyonunu bu kadar verimli yapan teknolojiyi keşfedin</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {howItWorks.map(h => (
                <div key={h.title} className="flex gap-4 bg-[#f8fafc] rounded-lg p-6 border border-gray-100">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#0f1117] rounded-lg text-[#e8600a] shrink-0"><i className={`${h.icon} text-xl`}></i></span>
                  <div>
                    <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{h.title}</h3>
                    <p className="text-xs text-gray-600 leading-relaxed">{h.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Minutes vs Hours */}
        <section className="py-20 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">Dakikalık Migrasyon, Saatlerce Kesintiyi Azaltma</h2>
            <p className="text-gray-400 mb-6 leading-relaxed text-sm">Pek çok satıcı VM'leri dakikalar içinde migrate ettiğini iddia eder ancak bu doğru değildir. Örneğin 100 VM'yi saatte ikişer tanesi migrate etmek toplam 50 saat, 1.000 VM ise 33 saat alır. Bu düzeyde migrasyon çoğu işletme için kabul edilemez üretkenlik kaybı ve önemli kesinti süresi anlamına gelir. <strong className="text-white">VergeOS ile 100 VM'yi veya 1.000 VM'yi saniyeler içinde migrate edebilirsiniz.</strong></p>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-[#f8fafc] border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">ioMigrate SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-white rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0"><i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i></span>
                  </button>
                  {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
